var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRightNormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 13.5L12 9L7.5 4.5",
    stroke: "url(#paint0_linear_3481_13158)",
    strokeWidth: 1.5,
    strokeLinecap: "square"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3481_13158",
    x1: 6.23438,
    y1: 3.59434,
    x2: 3.85738,
    y2: 10.3701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#624CE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A459FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightNormal);
export default __webpack_public_path__ + "static/media/ArrowRightNormal.aa243ad749a1f7a44eec37b6c5bc5de1.svg";
export { ForwardRef as ReactComponent };